import styled from 'styled-components/macro';
import { mediaDesktop } from 'breakpoints';
import theme from 'components/theme';

export const BundleCardWrapper = styled.div<{ $bundleLength?: number }>`
  cursor: pointer;
  position: relative;
  ${mediaDesktop} {
    ${({ $bundleLength }) => $bundleLength
      && $bundleLength > 1
      && {
        boxShadow: `10px -10px 0 0 #212121, 10px -10px 0 1px #373737${
          $bundleLength > 2 ? ', 20px -20px 0 0 #141414, 20px -20px 0 1px #2b2b2b' : ''
        }`,
      }}
  }
  border-radius: 5.6% / 3.4%;
`;

export const BundleLabel = styled.div`
  position: absolute;
  top: 20px;
  left: -10px;
  background-color: ${theme.colors.textWhite};
  padding: 2px 10px;
  border-radius: 4px;
  letter-spacing: 1px;
  font-weight: bold;
  font-family: ${theme.fonts.primary};
  font-size: 15px;
  ${mediaDesktop} {
    left: -16px;
  }
`;
